<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">Hi~ <a class="font3">{{ ReportData.stuname }}</a>，我们又见面啦</p>
        <p  class="font1" style="padding-top: 1vh;">勤学不辍，硕果累累</p>
        <!-- 有学习天数，有学习时长 -->
        <div  v-if="ReportData.studate !==null && ReportData.playtime !==null">
            <p  class="font1" style="padding-top: 1.5vh;">在这段时光里</p>
            <p class="font1">你在富学宝典平台上学习了<a class="font3">{{ ReportData.studate }}</a>天</p>
            <p class="font1" v-if="ReportData.playtime !==0">累计学习了<a class="font3">{{ ReportData.playtime }}</a>小时</p>
            <p  class="font1" style="padding-top: 4vh;">每一天的学习都是你进步的见证</p>
            <p class="font1">每一个刻苦学习的瞬间都是未来成功的基石</p>
            <div style="padding-top: 6vh;text-align: center;">
                <p style="margin: 0;">继续保持这份热情</p>
                <p style="margin: 0;">你的梦想终将实现</p>
            </div>
            <p style="padding-top: 3vh;text-align: center;">赶快开启专属于你的十一月学习报告吧</p>
        </div>
        <!-- 有学习天数，没学习时长 -->
        <div  v-if="ReportData.studate !==null && ReportData.playtime ==null">
            <p  class="font1" style="padding-top: 1.5vh;">在过去的一个月中</p>
            <p class="font1">你累计学习了<a class="font3">{{ ReportData.studate }}</a>天</p>
            <p  class="font1" style="padding-top: 1.5vh;">这些点滴的积累</p>
            <p class="font1">正在逐步塑造一个更加优秀的你</p>
        </div>
        <!-- 没有学习天数，没学习时长 -->
        <div  v-if="ReportData.studate ==null && ReportData.playtime ==null">
            <p  class="font1" style="padding-top: 1.5vh;">在过去的一个月中</p>
            <p class="font1">你还没有在富学宝典上学习</p>
            <p class="font1">请继续加油!</p>
        </div>

        <!-- <p class="font1" v-if="ReportData.coursenumMon !==null" style="padding-top: 1.5vh;">学习了<a class="font3">{{ ReportData.coursenumMon }}</a>门课程</p>
        <p class="font1" v-if="ReportData.coursenum !==null && ReportData.coursenum !==0" >完成了<a class="font3">{{ ReportData.coursenum }}</a>门课程</p>

        <p class="font1" v-if="ReportData.examTimes !==null" style="padding-top: 1.5vh;">累计考试<a class="font3">{{ ReportData.examTimes}}</a>次</p>
        <p class="font1" v-if="ReportData.creditvalue !==null">获得学分<a class="font3">{{ ReportData.creditvalue }}</a>分</p> -->
        
    </div>
</template>
  
<script>

export default {
    props: [ "ReportData"],
    data() {
    return {   
    }
    },
    created() {
    
    }
}
</script>
  
<style scoped>       
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/logo1.png") right  top  no-repeat,
                url("../../assets/24October/icon.png") 49% calc(100% + 50px) no-repeat,
                url("../../assets/24November/bg.jpg")  no-repeat;
    background-size: 17% 8%,110px 35px, 68%,cover;
    width: 100%;
    height: 100vh;
}

.font1 {
    width: 92%;
    padding-left: 8%;
    margin: 0;
    text-align: left;
    font-size: 18px;
    color: #000;
    /* font-weight: bold; */
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    color: #000;
    font-size: 15px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 25px;
    color: #46429e;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>